module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_9006.30eda943.png";